"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _phone = require("./phone");
Object.keys(_phone).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _phone[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _phone[key];
    }
  });
});
var _email = require("./email");
Object.keys(_email).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _email[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _email[key];
    }
  });
});